module.exports = __webpack_public_path__ + "static/media/journal-style-04.cb15dde5.svg";